import React, { useState } from "react";
import axios from "axios";
import { Loader2, Shield, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InternalLoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, {
        email, password, login_context: "internal",
      }, { withCredentials: true });
      localStorage.setItem("ic_token", res.data.token);
      localStorage.setItem("ic_user", JSON.stringify(res.data.user));
      axios.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;
      onLogin(res.data.user);
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#022c22] flex items-center justify-center px-4" data-testid="internal-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-emerald-900 border border-emerald-700 flex items-center justify-center mx-auto mb-4">
            <Shield className="h-7 w-7 text-emerald-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Internal Portal</h1>
          <p className="text-sm text-emerald-400/70 mt-1">Imaani Capital Operations</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#0a3d2e] rounded-2xl border border-emerald-800/50 p-8 space-y-5">
          {error && (
            <div className="flex items-center gap-2 p-3 rounded-xl bg-red-900/30 border border-red-700/50 text-red-300 text-xs" data-testid="internal-login-error">
              <AlertCircle className="h-4 w-4 shrink-0" />
              {error}
            </div>
          )}

          <div>
            <label className="block text-xs font-semibold text-emerald-300/80 mb-1.5">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
              data-testid="internal-login-email"
              className="w-full px-4 py-3 rounded-xl bg-[#022c22] border border-emerald-700/50 text-white text-sm placeholder:text-emerald-600/50 focus:outline-none focus:border-emerald-500"
              placeholder="you@imaani.com" />
          </div>

          <div>
            <label className="block text-xs font-semibold text-emerald-300/80 mb-1.5">Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
              data-testid="internal-login-password"
              className="w-full px-4 py-3 rounded-xl bg-[#022c22] border border-emerald-700/50 text-white text-sm placeholder:text-emerald-600/50 focus:outline-none focus:border-emerald-500"
              placeholder="Enter your password" />
          </div>

          <button type="submit" disabled={loading} data-testid="internal-login-submit"
            className="w-full py-3 rounded-xl bg-emerald-600 text-white text-sm font-bold hover:bg-emerald-500 transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Sign In to Operations
          </button>

          <p className="text-center text-[10px] text-emerald-600/50 mt-4">
            This portal is for authorized internal team members only.
          </p>
        </form>
      </div>
    </div>
  );
}
